import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

export default {
    defaultProps: {
        cssOverrides: {
            formInputWrapper: css`
                margin-top: 4px !important;
                input {
                    height: 40px !important;
                    padding: 12px 13px;
                }
            `,
            formField: css`
                label[class^="TypographyStyle"] {
                    font-family: ${TYPOGRAPHY.fontFamily.title};
                    font-style: normal;
                    font-weight: 600;
                    font-size: 14px;
                    line-height: 22px;
                    color: ${getColor("text.main")};
                }
            `,
        },
    },
};
